<template>
  <div class="margin-bottom-m">
    <Checkbox
      v-model="checkboxValue"
      name="show-subscription"
      :options="checkboxOptions"
    />

    <div
      v-if="autoReplenishmentEnabled"
      class="frequency-dropdown dropdown-wrapper"
    >
      <Dropdown
        v-model="frequency"
        name="frequency"
        :options="frequencyOptions"
        label="Ships Every*"
      />

      <p class="select-helper-text small">
        You can change the frequency, cancel, or reschedule at any time online. We will remind you via email before each shipment.
      </p>
    </div>
  </div>
</template>

<script setup>
import {
  defineComponent,
  h,
  computed,
} from 'vue';
import Checkbox from '@atomic-ui/checkboxBasic';
import Dropdown from '@atomic-ui/dropdown';
import { useFeatureEligibility, useProductFlags } from '@modules/featureControl';
import AutoReplenishmentLabel from './AutoReplenishmentLabel';

import { useAutoReplenishment } from '../composables';

defineComponent({
  name: 'AutoReplenishment',
});

const { isChanelFlag } = useProductFlags();
const { isRemoveSaveForBeautyEligible, isDior } = useFeatureEligibility();
const { frequency, frequencyOptions, autoReplenishmentEnabled } = useAutoReplenishment();

const checkboxLabel = computed(() => (isRemoveSaveForBeautyEligible
  ? 'Subscribe and get free shipping on orders over $20. '
// eslint-disable no-trailing-spaces
  : 'Subscribe to get 5% off your second order and all future shipments. Free shipping on orders over $20. '));

/**
 * * Adapter from boolean to array for atomic ui Checkbox component
 * Checkbox component has weird contract
 */
const checkboxValue = computed({
  get: () => (autoReplenishmentEnabled.value ? [true] : []),
  set: (newValue) => {
    autoReplenishmentEnabled.value = !!newValue[0];
  },
});

const checkboxOptions = [{
  id: 'subscribe',
  label: h(
    AutoReplenishmentLabel,
    {
      freeShipping: isChanelFlag || isDior,
    },
    () => [checkboxLabel.value],
  ),
  labelType: 'html',
  ariaLabel: checkboxLabel.value,
  value: true,
}];

</script>

<style lang="scss" brand="mcom">
.frequency-dropdown {
  .select-helper-text {
    color: $gray-1-color;
  }
}
</style>
